
import useEmblaCarousel from "embla-carousel-react";
import React, { useCallback, useImperativeHandle, forwardRef } from "react";


export interface EmblaCarouselHandle {
    scrollPrev: () => void;
    scrollNext: () => void;
  }

const EmblaCarouselComponent = forwardRef<EmblaCarouselHandle, {}>(
    ({  }, ref) => {

        const [emblaRef, emblaApi] = useEmblaCarousel({ 
            loop: false,
            slidesToScroll: "auto"
        });
    
        const scrollPrev = useCallback(() => {
            if (emblaApi) emblaApi.scrollPrev();
        }, [emblaApi]);
    
        const scrollNext = useCallback(() => {
            if (emblaApi) emblaApi.scrollNext();
        }, [emblaApi]);
    
    
        // Exponer métodos a través de la ref
        useImperativeHandle(ref, () => ({
            scrollPrev,
            scrollNext,
        }));

        const testimonios = [
            {
                title: 'María, 29 años',
                description:
                    'Moni me ha facilitado llevar un registro detallado de mis gastos. Es increíblemente sencillo y cómodo usarlo desde WhatsApp.',
                img: '/img/marketing/testimonials/testi_ex1.jpg',
            },
            {
                title: 'Luis, 35 años',
                description:
                    'Antes me costaba mucho mantener un control de mis finanzas, pero con Moni todo es automático y mucho más seguro.',
                img: '/img/marketing/testimonials/testi_ex2.jpg',
            },
            {
                title: 'María, 29 años 1',
                description:
                    'Moni me ha facilitado llevar un registro detallado de mis gastos. Es increíblemente sencillo y cómodo usarlo desde WhatsApp.',
                img: '/img/marketing/testimonials/testi_ex1.jpg',
            },
            {
                title: 'Luis, 35 años 1',
                description:
                    'Antes me costaba mucho mantener un control de mis finanzas, pero con Moni todo es automático y mucho más seguro.',
                img: '/img/marketing/testimonials/testi_ex2.jpg',
            },
            {
                title: 'María, 29 años 2',
                description:
                    'Moni me ha facilitado llevar un registro detallado de mis gastos. Es increíblemente sencillo y cómodo usarlo desde WhatsApp.',
                img: '/img/marketing/testimonials/testi_ex1.jpg',
            },
            {
                title: 'Luis, 35 años 2',
                description:
                    'Antes me costaba mucho mantener un control de mis finanzas, pero con Moni todo es automático y mucho más seguro.',
                img: '/img/marketing/testimonials/testi_ex2.jpg',
            }
        ]
        return (
            <div className="embla max-w-72 sm:max-w-full ">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container mb-6">
                    {testimonios.map((item, index) => (
                        <div
                            key={index}
                            className="embla__slide grow-0 shrink-0 basis-full sm:basis-2/4"
                        >
                            <div className="card rounded-2xl bg-white p-6 md:p-10 text-body-sm md:text-body-md shadow-lg">
                                <div className="mb-4 md:pr-4">{item.description}</div>
                                <div className="flex flex-wrap md:flex-nowrap  items-center">
                                    <div className="w-full md:w-16 shrink-0">
                                        <img src={item.img} alt="Maria" className='m-auto' />
                                    </div>
                                    <div className="w-full py-4 md:p-4 font-semibold text-center md:text-left">{item.title}</div>
                                    <div className="hidden md:block w-14 shrink-0">
                                        <img
                                            src="/img/marketing/testimonials_quote.svg"
                                            alt="quotes"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
        );
    }
);
EmblaCarouselComponent.displayName = "EmblaCarouselComponent";
export default EmblaCarouselComponent;